import { useHistory } from "react-router-dom";
import { Col, message, Row } from "antd";
import { useRef, useState } from "react";

import Table from "@components/Table";
import Button from "@components/Button";
import { getColumns } from "./config";
import {
  ErrorServices,
  useDeleteShortTermPlanMutation,
  useFetchShortTermPlansQuery,
} from "@services";
import { IShortTermPlan } from "@types";
import { paths, permissions } from "@router";
import AddShortTermPlan from "./AddShortTermPlan";
import { useTypedSelector } from "@hooks";
import { checkPermission } from "@/utils";
import SearchBox from "@/components/searchInput";
import CustomButton from "@/components/customButton";
import { MdOutlineFileDownload, MdOutlineFileUpload } from "react-icons/md";

const ShortTermPlans = () => {
  const { company } = useTypedSelector(state => state.auth?.user!);
  const { id: company_id } = company!;
  const history = useHistory();
  const shortTermPlan_id = useRef<any>(null);
  const [page, setPage] = useState(1);

  const [isVisible, setIsVisible] = useState(false);
  const [searchInput, setSearchInput] = useState("");
  const [isVisibleForEdit, setIsVisibleForEdit] = useState(false);

  const [selectedShortTermPlan, setSelectedShortTermPlan] =
    useState<IShortTermPlan | null>(null);
  const [deleteShortTermPlan, { isLoading: isDeleting }] =
    useDeleteShortTermPlanMutation();
  const { data: plansData, isLoading } = useFetchShortTermPlansQuery({
    company_id,
    page,
  });
  const { data, pagination } = plansData || {};

  const onRowClick = (data: any) => {
    // history.push(`${window.location.pathname}/${data?.id}`);
    return;
  };

  const removeShortTermPlan = async (id: number) => {
    try {
      shortTermPlan_id.current = id;
      await deleteShortTermPlan({ company_id, id }).unwrap();
      message.success("Short term incentive plan deleted successfully!");
    } catch (error) {
      ErrorServices(error);
    }
  };

  const editShortTermPlan = (selectedShortTermPlan: IShortTermPlan) => {
    setSelectedShortTermPlan(selectedShortTermPlan);
    setIsVisibleForEdit(true);
  };

  const columns = getColumns({
    isDeleting,
    shortTermPlan_id,
    removeShortTermPlan,
    editShortTermPlan,
  });

  return (
    <>
      {isVisible && (
        <AddShortTermPlan
          selectedShortTermPlan={selectedShortTermPlan}
          setSelectedShortTermPlan={setSelectedShortTermPlan}
          isVisible={isVisible}
          setIsVisible={setIsVisible}
        />
      )}
      {isVisibleForEdit && (
        <AddShortTermPlan
          selectedShortTermPlan={selectedShortTermPlan}
          setIsVisible={() => {
            setIsVisibleForEdit(false);
            setSelectedShortTermPlan(null);
          }}
          setSelectedShortTermPlan={setSelectedShortTermPlan}
          isVisible={isVisibleForEdit}
          isEdit={true}
        />
      )}

      <div className="bg-themeCore ">
        <div className="jobCreationBar bg-white px-4 py-6 rounded-lg flex justify-between items-center ">
          <div className="title text-themeBlue  font-medium text-3xl">
            Short Term Incentive Plans
          </div>

          <div className="flex flex-row justify-between">
            <CustomButton
              onClick={() =>
                history.push(paths.client.short_term_ip.incentives)
              }
              btnName="STI Data"
              customClasses="shadow-md font-medium border py-1 px-6 !border-themeBorder"
              iconPosition="left"
            ></CustomButton>

            {checkPermission(permissions.CREATE_COMPANY_STI) && (
              <CustomButton
                onClick={() => setIsVisible(true)}
                btnName="Create STI Plan"
                customClasses="shadow-md font-medium border py-1 px-6 !border-themeBorder ml-4"
                iconPosition="right"
              >
                <MdOutlineFileDownload
                  size={20}
                  className="text-white font-bold"
                />
              </CustomButton>
            )}
          </div>
        </div>
      </div>

      <div className="jobCreationListing mt-10 bg-white px-14 py-6 rounded-lg">
        <SearchBox
          placeholder="Type to search..."
          value={searchInput}
          onChange={value => setSearchInput(value)}
        />
        <Row>
          <Table
            scroll={1500}
            data={data}
            columns={columns}
            isLoading={isLoading}
            pagination={true}
            count={pagination?.count}
            onChangePage={setPage}
            page={page}
            onRowClick={onRowClick}
          />
        </Row>
      </div>
    </>
  );
};

export default ShortTermPlans;
